"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blue = {
  1: '#F7FAFF',
  2: '#AFD2FF',
  3: '#2E7EE7',
  4: '#236AC8',
  5: '#235390'
};
var _default = blue;
exports.default = _default;